import { API_ROOT } from '../../config/config'
import { doGet, doPost, doPut } from './utils'

// const API_ROOT = 'http://localhost:9010/api'

export const getThaiDAuthenUrl = (refCode) => {
  const url = `${API_ROOT}/authen/thaid/get-authen-url?refCode=${refCode}`
  return doGet(url)
}

export const thaiDUpdateData = (request) => {
  const url = `${API_ROOT}/authen/thaid/update-data`
  return doPut(url, request)
}
